export default __webpack_public_path__ + "static/media/exam_edition_1.dcfe7aa9.jpg";